import(/* webpackMode: "eager" */ "/vercel/path0/app/(globalroutes)/pizza/error.tsx");
